import { render, staticRenderFns } from "./RequestTransferModal.vue?vue&type=template&id=13b6abcf&"
import script from "./RequestTransferModal.vue?vue&type=script&lang=js&"
export * from "./RequestTransferModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports